const mutations = {
    DATA_SUCCESS: (state, payload) => {
        state.dataStatus = 'success';
        state.extData[payload.type] = payload.response.data[payload.type];
    },
    DATA_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.dataStatus = 'error';
        state.dataErrors.record(errors);
    }
}

export default mutations
